import { render, staticRenderFns } from "./IpConfig.vue?vue&type=template&id=ae7072dc&"
import script from "./IpConfig.vue?vue&type=script&lang=js&"
export * from "./IpConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports